<template>
   <div id="layoutDefault">
            <div id="layoutDefault_content">
                <main>
                    <MainNav />
                    <header class="page-header page-header-dark bg-gradient-primary-to-secondary">
                        <div class="page-header-content">
                        </div>
                        <div class="svg-border-rounded text-light">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.54 17.34" preserveAspectRatio="none" fill="currentColor"><path d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0" /></svg>
                        </div>
                    </header>
                    <section class="bg-light py-10">
                        <div class="container">
                            <div class="row justify-content-center">
                                <div class="col-lg-10 col-xl-8">
                                    <div class="single-post">
                                        <h1>Living Well with Inflammatory Bowel Disease: A Self-Management Handbook for Patients &amp; Families with IBD</h1>
                                        <p class="lead">Working together, we can come up with the best plan for you, but we all have some work
                                                    to do. We need to learn about you. You and your family are the best people to teach us.
                                                    You and your family need to learn about IBD and about our team, and we are here to help
                                                    you do that. We wrote this book to help you learn about IBD and understand your part on
                                                    our team. Your participation is very important to us and to your health! </p>
                                        <div class="d-flex align-items-center justify-content-between mb-5">
                                            <div class="single-post-meta mr-4">
                                                <div class="single-post-meta-details">
                                                    <div class="single-post-meta-details-name"><i class="fas fa-tag"></i> Featured</div>
                                                    <div class="single-post-meta-details-date">Feb 5 &#xB7; 26 min read</div>
                                                </div>
                                            </div>
                                        </div>
                                        <img class="img-fluid mb-2" src="https://d3n8a8pro7vhmx.cloudfront.net/improvecarenow/pages/264/attachments/original/1456001033/cover_of_book.jpg?1456001033" />
                                        <div class="single-post-text my-5">
                                            <p>Informally known as "The Handbook" this is a comprehensive resource for patients and families who are learning about these conditions. Living Well with Inflammatory Bowel Disease: 
                                                A Self-Management Handbook for Patients &amp; Families with IBD is also a companion and guide for those who are living with IBD and want to participate more actively in their own care. 
                                            </p>
                                            <p>The Handbook is the result of collaboration between pediatric IBD experts at Nationwide Children’s Hospital (Columbus, OH) and Cincinnati Children’s Hospital Medical Center (Cincinnati, OH).  
                                                It combines comprehensive clinical knowledge with practical tips and suggestions from parents and kids - just like you - who are living with IBD.
                                            </p>
                                            <a href="https://d3n8a8pro7vhmx.cloudfront.net/improvecarenow/pages/264/attachments/original/1456001031/handbook.pdf?1456001031" target="_blank" onclick="dataLayer.push({'event': 'download-pdf-handbook'});"><i class="fas fa-file-pdf"></i> Download Handbook</a>
                                            <div class="text-center"><router-link class="btn btn-transparent-dark btn-marketing rounded-pill" to="/resource-list">Back to Resources</router-link></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="svg-border-rounded text-dark">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.54 17.34" preserveAspectRatio="none" fill="currentColor"><path d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0" /></svg>
                        </div>
                    </section>
                </main>
            </div>
            <div id="layoutDefault_footer">
                <MainFooter />
            </div>
        </div>
</template>

<script>
import $ from 'jquery';
import MainNav from '@/components/nav.vue'
import MainFooter from '@/components/footer.vue'

export default {
  name: 'Home',
  components: {
    MainNav,
    MainFooter
  }
}
// Collapse Navbar
// Add styling fallback for when a transparent background .navbar-marketing is scrolled
var navbarCollapse = function() {
    if($(".navbar-marketing.bg-transparent.fixed-top").length === 0) {
        return;
    }
    if ($(".navbar-marketing.bg-transparent.fixed-top").offset().top > 0) {
        $(".navbar-marketing").addClass("navbar-scrolled");
    } else {
        $(".navbar-marketing").removeClass("navbar-scrolled");
    }
};
// Collapse now if page is not at top
navbarCollapse();
// Collapse the navbar when page is scrolled
$(window).scroll(navbarCollapse);



</script>
